import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ProductCardProps {
  title: string;
  description: string;
  features: string[];
  icon: React.ReactNode;
  buttonText?: string;
  buttonUrl?: string;
}
export function ProductCard({
  title,
  description,
  features,
  icon,
  buttonText = 'Learn more',
  buttonUrl
}: ProductCardProps) {
  const buttonContent = <>
      {buttonText}
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover/btn:translate-x-1" data-id="element-44" />
    </>;
  const buttonClasses = 'group/btn inline-flex items-center gap-2 text-sm font-medium text-gray-300 transition-all hover:text-white min-w-[180px] mt-auto';
  return <div className="group relative h-full rounded-2xl border border-white/10 bg-gradient-to-br from-[#1a1a1a] to-black p-8 transition-all duration-300 hover:border-white/20 hover:shadow-xl hover:shadow-black/50 flex flex-col" data-id="element-45">
      <div className="p-1 mb-6 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-white/5 text-gray-300" data-id="element-46">
        {icon}
      </div>

      <h3 className="mb-3 text-2xl font-bold text-white" data-id="element-47">{title}</h3>
      <p className="mb-8 text-gray-400 leading-relaxed" data-id="element-48">{description}</p>

      <div className="mb-8 space-y-3" data-id="element-49">
        {features.map((feature, index) => <div key={index} className="flex items-start gap-3" data-id="element-50">
            <div className="mt-1.5 h-1.5 w-1.5 rounded-full bg-gray-500" data-id="element-51" />
            <span className="text-sm text-gray-300" data-id="element-52">{feature}</span>
          </div>)}
      </div>

      {buttonUrl ? <a href={buttonUrl} target="_blank" rel="noopener noreferrer" className={buttonClasses} data-id="element-53">
          {buttonContent}
        </a> : <button className={buttonClasses} data-id="element-54">{buttonContent}</button>}
    </div>;
}